__turbopack_context__.v({
  "root": "WalletStats-module__ZTQyLG__root",
});
